import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { useTheme, THEMES } from "@/context/ThemeContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { trackEvent } from "@/lib/api";
import { ArrowRight, Menu, Check, Palette } from "lucide-react";
import { BrandMark } from "./BrandMark";

export const MobileMenu = () => {
    const [open, setOpen] = useState(false);
    const { theme, setTheme } = useTheme();
    return (
        <div className="sm:hidden flex items-center shrink-0">
            <Sheet open={open} onOpenChange={setOpen}>
                <SheetTrigger asChild>
                    <button
                        type="button"
                        aria-label="Open menu"
                        data-testid="mobile-menu-trigger"
                        className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-border/70 hover:bg-muted transition-colors"
                    >
                        <Menu className="h-5 w-5" strokeWidth={1.5} />
                    </button>
                </SheetTrigger>
                <SheetContent
                    side="right"
                    className="w-[85vw] max-w-sm p-0 flex flex-col"
                    data-testid="mobile-menu-sheet"
                >
                    <SheetTitle className="sr-only">Navigation menu</SheetTitle>
                    <div className="px-6 pt-6 pb-4 border-b border-border/60">
                        <BrandMark />
                    </div>
                    <nav className="flex-1 px-4 py-4 space-y-1">
                        <Link
                            to="/pricing"
                            onClick={() => setOpen(false)}
                            className="block px-3 py-3 rounded-lg font-display text-lg hover:bg-muted transition-colors"
                            data-testid="mobile-menu-pricing"
                        >
                            Pricing
                        </Link>
                        <a
                            href="#templates"
                            onClick={() => setOpen(false)}
                            className="block px-3 py-3 rounded-lg font-display text-lg hover:bg-muted transition-colors"
                            data-testid="mobile-menu-templates"
                        >
                            Templates
                        </a>
                        <Link
                            to="/login"
                            onClick={() => setOpen(false)}
                            className="block px-3 py-3 rounded-lg font-display text-lg hover:bg-muted transition-colors"
                            data-testid="mobile-menu-signin-link"
                        >
                            Sign in
                        </Link>
                        <div className="pt-4">
                            <div className="mono-label px-3 pb-2 text-muted-foreground inline-flex items-center gap-2">
                                <Palette className="h-3 w-3" strokeWidth={1.5} /> Ambient theme
                            </div>
                            <div className="grid grid-cols-2 gap-2 px-1">
                                {THEMES.map((t) => (
                                    <button
                                        key={t.id}
                                        type="button"
                                        onClick={() => setTheme(t.id)}
                                        data-testid={`mobile-menu-theme-${t.id}`}
                                        className={`flex items-center justify-between px-3 py-2.5 rounded-lg border text-sm font-display transition-colors ${
                                            theme === t.id
                                                ? "bg-foreground text-background border-foreground"
                                                : "border-border/70 hover:bg-muted"
                                        }`}
                                    >
                                        <span>{t.label}</span>
                                        {theme === t.id && <Check className="h-3.5 w-3.5" strokeWidth={1.5} />}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="pt-4 px-1">
                            <LanguageSwitcher />
                        </div>
                    </nav>
                    <div className="px-4 pb-6 pt-2 border-t border-border/60">
                        <Link to="/login" onClick={() => setOpen(false)} className="block">
                            <Button
                                className="w-full rounded-md font-display h-12"
                                data-testid="mobile-menu-signin"
                                onClick={() =>
                                    trackEvent("landing_cta_click", {
                                        location: "mobile_menu",
                                        label: "sign_in",
                                    })
                                }
                            >
                                Sign In
                                <ArrowRight className="ml-1 h-4 w-4" strokeWidth={1.5} />
                            </Button>
                        </Link>
                    </div>
                </SheetContent>
            </Sheet>
        </div>
    );
};
